import { useState } from "react";
import { presalesApi } from "../../api/presalesApi";

const CATEGORIES = ["engineering", "travel", "legal", "advisory", "event", "other"];

function fmtINR(paise) {
  if (!paise) return "—";
  const n = paise / 100;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (n >= 100000)   return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000)     return `₹${(n / 1000).toFixed(0)}k`;
  return `₹${n.toLocaleString("en-IN")}`;
}

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getDate().toString().padStart(2, "0")} ${d.toLocaleString("en", { month: "short" })}`;
}

export default function SpendTab({ lead, mutate, showToast }) {
  const spend = lead.spend || [];
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({
    description: "",
    category: "other",
    log_date: new Date().toISOString().slice(0, 10),
    amount: "",
  });
  const [saving, setSaving] = useState(false);

  const total = spend.reduce((s, x) => s + (x.amount || 0), 0);

  async function addEntry() {
    if (!form.amount || !form.log_date) return;
    setSaving(true);
    try {
      await presalesApi.addSpend(lead.id, {
        ...form,
        amount: Math.round(parseFloat(form.amount) * 100),
      });
      setForm({ description: "", category: "other", log_date: new Date().toISOString().slice(0, 10), amount: "" });
      setAdding(false);
      await mutate();
      showToast?.("Spend entry added", "success");
    } catch (err) {
      showToast?.(err.message || "Failed to add entry", "error");
    } finally {
      setSaving(false);
    }
  }

  async function deleteEntry(id) {
    try {
      await presalesApi.deleteSpend(id);
      await mutate();
    } catch (err) {
      showToast?.(err.message || "Failed to delete", "error");
    }
  }

  return (
    <div className="ps-so-section">
      <div className="ps-so-lbl">
        <span>Spend Log</span>
        <button onClick={() => setAdding((v) => !v)}>+ Add</button>
      </div>

      {adding && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 14 }}>
          <div className="ps-form-row two">
            <div className="ps-fld">
              <label>Description</label>
              <input type="text" value={form.description} placeholder="What for…"
                onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} />
            </div>
            <div className="ps-fld">
              <label>Category</label>
              <select value={form.category} onChange={(e) => setForm((p) => ({ ...p, category: e.target.value }))}>
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div className="ps-form-row two">
            <div className="ps-fld">
              <label>Date</label>
              <input type="date" value={form.log_date}
                onChange={(e) => setForm((p) => ({ ...p, log_date: e.target.value }))} />
            </div>
            <div className="ps-fld">
              <label>Amount (₹)</label>
              <input type="number" value={form.amount} placeholder="0"
                onChange={(e) => setForm((p) => ({ ...p, amount: e.target.value }))} />
            </div>
          </div>
          <div className="ps-form-acts">
            <button onClick={() => setAdding(false)}>Cancel</button>
            <button className="primary" disabled={!form.amount || !form.log_date || saving} onClick={addEntry}>
              {saving ? "Saving…" : "Add Entry"}
            </button>
          </div>
        </div>
      )}

      {spend.length === 0 ? (
        <div className="ps-so-empty">No spend entries</div>
      ) : (
        <div className="ps-spend-list">
          {spend.map((s) => (
            <div key={s.id} className="ps-spend-row">
              <div className="ps-spend-t">
                <span>{s.description || s.category}</span>
                <span className="meta">
                  {fmtDate(s.log_date)}
                  {s.logged_by_name ? ` · ${s.logged_by_name}` : ""}
                  {" · "}
                  {s.category}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span className="ps-spend-v">{fmtINR(s.amount)}</span>
                <button className="ps-spend-del" onClick={() => deleteEntry(s.id)}>×</button>
              </div>
            </div>
          ))}
          <div className="ps-spend-total">
            <span className="t">Total spend</span>
            <span className="v">{fmtINR(total)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
